import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { AddNewUnitForm, getSpaceCategory } from '../../../technologyoverlay';
import { TechnologyoverlayService } from '../../../technologyoverlay.service';
import { RollbarService } from '../../../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck,generateAlertMessage,AuthFailedMessage } from '../../../../../app-general';
import { appsettings } from '../../../../../app-settings';
import {Router} from '@angular/router';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-add-unit',
  templateUrl: './add-unit.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./add-unit.component.scss']
})
export class AddUnitComponent implements OnInit,OnDestroy {

  public addUnitForm : FormGroup;
  watcher: Subscription;
  columns: number = 2;
  SiteId = "1";
  addunitbool : boolean = true; 
  Space_details;
  private _onDestroy: Subject<void> = new Subject<void>();
  selectCategoryId;
  UnitData;
  space_polyPoints;
  checkResOffLimits = false;
  checkSpaceCategory = 0;     
  _roomenablehourmin = false;
  _roomenableroomallday = false;
  checkresroominfo = false;
  public Curfew_data = [];
  data_RstartTime;
  data_RendTime;
  
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<AddUnitComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private technologyoverlayService: TechnologyoverlayService,@Inject(RollbarService) private rollbar: Rollbar,
  public dialog: MatDialog) {
    this.getCurfew_data();
    this.UnitData = data.FloorData;
    this.space_polyPoints = data.Polypoints;
    
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        
        if (change.mqAlias == 'xs') {
          this.columns = 1;
        } 
        if (change.mqAlias == 'sm') {
          this.columns = 2;
        } 
        else {
          this.columns = 2;
        }  
        
      }
    });
   }
   
  getCurfew_data()
  {
    var _curfewdata={};
    var _curfew_data_arr = [];
    var hourtext = "";
    var _hour = "";
    var _min="";
    var min_inc=30;
    for(var hour = 0; hour <= 24; hour++) 
    {  
      if(hour < 12)
      {
        _hour = "0" + hour.toString();
        hourtext = " am";
      }
      else if(hour == 24)
      {
          _hour =  (hour-12).toString();
          hourtext = " am";
          min_inc=60;
      }   
      else if(hour > 12)
      {
        _hour = "0" + (hour-12).toString();
          hourtext = " pm";
      }    
      else if(hour == 12)
      {
          _hour = hour.toString();
          hourtext = " pm";
      }   
      
      _hour= _hour.slice(-2);
      for(var min = 0; min < 60; min=min+min_inc)
      {     
        _min = "0" + min.toString();  
        _min= _min.slice(-2);               
        _curfewdata = {Time:_hour + ":" + _min + hourtext, Value: hour + ":" + min }         
        _curfew_data_arr.push(_curfewdata);         
      }
      
    }   
        this.Curfew_data=_curfew_data_arr;     
  }
   
  ngOnInit() {
    try
    {      
        this.addUnitForm = new FormGroup({
          campusname: new FormControl(''),
          buildingname: new FormControl(''),
          zonename: new FormControl(''),
          campusID: new FormControl(''),
          buildID: new FormControl(''),
          floorID: new FormControl(''),
          unitname:new FormControl('',[Validators.required,Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
          category:new FormControl('', [Validators.required]),
          description: new FormControl('', [Validators.pattern(appsettings.Name_Pattern)]),
          res_start: new FormControl(''),
          res_end: new FormControl(''), 
        });
            
          this.addUnitForm.get('campusname').disable();   
          this.addUnitForm.get('buildingname').disable();   
          this.addUnitForm.get('zonename').disable();   
          
          this.getSpaceCategory();
    }
      catch (err) {
        throw new Error('add-unit.component.ts' + ' - ondelteUnit() - ' + err.message);
      }               
  }
  
  getSpaceCategory()
  {
    try
    {      
      var spaceitem : getSpaceCategory = 
      {
        siteId: this.SiteId,
        authKey: localStorage.getItem("Authkey"), 
        categoryId: 0
      }
      this.technologyoverlayService.getSpaceCategory(spaceitem).pipe(takeUntil(this._onDestroy))
      .subscribe((spacedetails: any[]) => {
        this.Space_details = spacedetails;                           
      });
    }
    catch (err) {
      throw new Error('add-unit.component.ts' + ' - getSpaceCategory() - ' + err.message);
    }
  }

  handleInput(event) 
  {
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.addUnitForm.controls).forEach(field => { // {1}
        const control = this.addUnitForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('add-unit.component.ts' + ' - handleInput() - ' + err.message);
    }
  }

  public onCloseCancel = () => {   
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
    
  }

  public hasError = (controlName: string, errorName: string) =>{
    return this.addUnitForm.controls[controlName].hasError(errorName);
  }
  
  selectSpaceCategory(categoryId)
  {       
   
    this.selectCategoryId = categoryId;     
  }
  
  newaddUnit(addUnitFormValue)
  {
    try
    { 
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      } 
      
        if (this.addUnitForm.valid ) {
          let saveclick = document.getElementById('btnsaveunitaddclick');
          saveclick.className = 'clsaddunitbutton mat-raised-button disablebtn';          
            this.addSpaceWithRoom(addUnitFormValue);
      }
    }
    catch (err) {
      throw new Error('add-unit.component.ts' + ' - newaddUnit() - ' + err.message);
    }    
  }

  private addSpaceWithRoom = (addUnitFormValue) => {    
    try
    {   
      (document.activeElement as HTMLTextAreaElement).blur();
  
      var check_Room_AllDay;        
      var resstarttime, resendtime;        
      var res_Start_Hr, res_Start_Min;
      var res_End_Hr, res_End_Min;      
      if (this.addUnitForm.valid && this.addunitbool) {
            let saveclick = document.getElementById('btnsaveunitaddclick');
            saveclick.className = 'clsaddunitbutton mat-raised-button disablebtn';  
            this.addunitbool = false;           
            let _Description = "";        
            if(addUnitFormValue.description != "")
              _Description = addUnitFormValue.description.replace(/\s+/g, ' ').trim();
            else
              _Description = "";
              
              var resofflimits = 0;
          
            if(this.checkResOffLimits == true)
              resofflimits = 1;
            else
              resofflimits = 0;
              
          if(addUnitFormValue.res_start != undefined && addUnitFormValue.res_start != 0)
          {
            resstarttime = addUnitFormValue.res_start.split(":");
          res_Start_Hr = parseInt(resstarttime[0]);
            res_Start_Min = resstarttime[1].split(" ");        
          res_Start_Min = parseInt(res_Start_Min[0]);
          }
          if(addUnitFormValue.res_end != undefined && addUnitFormValue.res_end != 0)
          {
            resendtime = addUnitFormValue.res_end.split(":");        
          res_End_Hr = parseInt(resendtime[0]);
            res_End_Min = resendtime[1].split(" ");        
          res_End_Min = parseInt(res_End_Min[0]);
          }
              
          if(this.checkresroominfo == true)        
            check_Room_AllDay = 1;
          else
            check_Room_AllDay = 0;
          
          if(resofflimits == 1)  
          {
            if ((addUnitFormValue.res_start == "" || addUnitFormValue.res_start == undefined) && (addUnitFormValue.res_end == "" ||
            addUnitFormValue.res_end == undefined) && (this.checkresroominfo == false || this.checkresroominfo == undefined)) 
            {              
              generateAlertMessage(this.dialog,"Please select Resident Time info or All");
              saveclick.className = 'clsaddunitbutton mat-raised-button';  
              this.addunitbool = true; 
              return false;
            }

            if (addUnitFormValue.res_start != "" && addUnitFormValue.res_start != undefined) 
            {
              if (addUnitFormValue.res_end == "" || addUnitFormValue.res_end == undefined) 
              {                
                generateAlertMessage(this.dialog,"Please select Resident End time");
                saveclick.className = 'clsaddunitbutton mat-raised-button';   
                this.addunitbool = true;
                return false;
              }
            }

            if (addUnitFormValue.res_end != "" && addUnitFormValue.res_end != undefined) 
            {
              if (addUnitFormValue.res_start == "" || addUnitFormValue.res_start == undefined) 
              {                
                generateAlertMessage(this.dialog,"Please select Resident Start time");
                saveclick.className = 'clsaddunitbutton mat-raised-button';   
                this.addunitbool = true;
                return false;
              }
            }
          }
          
          // if(resofflimits == 1 && check_Room_AllDay == 0 && res_Start_Hr >= 0 && res_End_Hr < res_Start_Hr )  
          // {            
          //     generateAlertMessage(this.dialog,"Start time should be lesser than the End time");
          //     saveclick.className = 'clsaddunitbutton mat-raised-button';   
          //     this.addunitbool = true;
          //     return false;            
          // }
          // else if(resofflimits == 1 && check_Room_AllDay == 0 && res_Start_Hr == res_End_Hr && res_Start_Min >= res_End_Min) 
          // {
          //   generateAlertMessage(this.dialog,"Start time should be lesser than the End time");
          //   saveclick.className = 'clsaddunitbutton mat-raised-button';   
          //   this.addunitbool = true;
          //   return false;
          // }
              
            let unitdetails: AddNewUnitForm = {
                siteId: this.SiteId,
                authKey: localStorage.getItem("Authkey"),
                campusId:parseInt(addUnitFormValue.campusID),
                buildId:parseInt(addUnitFormValue.buildID),
                floorId:parseInt(addUnitFormValue.floorID),
                unitName:addUnitFormValue.unitname.replace(/\s+/g, ' ').trim(),                
                description:_Description,//addUnitFormValue.description.replace(/\s+/g, ' ').trim(),              
                spaceCategoryId:parseInt(this.selectCategoryId),
                svgpoints: this.space_polyPoints.toString(),
                isIndoor:1,
                accuracy:"",
                resOffLimits:resofflimits,    
                spaceId:0,            
                chkAllday : check_Room_AllDay,
                resStartHr : res_Start_Hr,
                resStartMi : res_Start_Min,
                resEndHr : res_End_Hr,
                resEndMi : res_End_Min,
                roomX:0,  
                roomY:0,
              }
                   
            this.technologyoverlayService.addSpaceWithRoom(unitdetails).pipe(takeUntil(this._onDestroy))
            .subscribe((apiresponse : any[])=>{
                if(apiresponse["apiReturn"].toString() == "Success")
                { 	
                  generateAlertMessage(this.dialog, 'Space added successfully.');               
                  this.thisDialogRef.close('Confirm');
                }
                else if(apiresponse["apiReturn"].toString() == "Fail")
                { 	    
                  this.addunitbool = true;
                  generateAlertMessage(this.dialog, 'Space added failed.');          
                  this.thisDialogRef.close('Confirm');
                }                
                else if(apiresponse["apiReturn"] == "Invalid Auth Key")
                {    
                    this.thisDialogRef.close('close');              
                    AuthFailedMessage(this.dialog,this.router);  
                    return;       
                } 
                else if(apiresponse["apiReturn"] == "Unit Name empty")
                {
                  this.addunitbool = true;
                  generateAlertMessage(this.dialog, 'Please enter Space Name');                  
                  saveclick.className = 'clsaddunitbutton mat-raised-button'; 
                  return; 
                }
                else if (apiresponse["apiReturn"] == "SpaceId") {
                  this.addunitbool = true;
                  generateAlertMessage(this.dialog, "Space Id already exists, Please try with different Id.");          
                  saveclick.className = 'clsaddoutsavebutton mat-raised-button'; 
                  return;
                }
                else
                { 	    
                  this.addunitbool = true;
                  generateAlertMessage(this.dialog, "Space name '" + apiresponse["apiReturn"][0].UnitName + "' already exists."); 
                  saveclick.className = 'clsaddunitbutton mat-raised-button';  
                  return;
                }  
                
                document.getElementById('container_DeviceList').className = "enablebtn";
                document.getElementById('container_SelectMove').className = "enablebtn";
                document.getElementById('container_EditSpace').className = "enablebtn";
                document.getElementById('container_AddDevice').className = "enablebtn";
                document.getElementById('container_Duplicate').className = "enablebtn";
                document.getElementById('container_InsertTemplate').className = "enablebtn";
                document.getElementById('container_DeleteSpace').className = "enablebtn";
                var saveBtn = document.getElementById("btnsaveclickmapview"); 
                if (saveBtn.innerHTML=="Done")  saveBtn.innerHTML= "Save";
            });
        }
      }
      catch (err) {
        throw new Error('add-unit.component.ts' + ' - addSpaceWithRoom() - ' + err.message);
      }         

}

toggler_ResOffLimits(e) {  
  if (e.checked == true) {
    this.checkResOffLimits=true;  
    this._roomenableroomallday = true; 
    this.checkresroominfo = true;
    if(this.checkresroominfo == true)
      this._roomenablehourmin = false;     
    else
      this._roomenablehourmin = true;     
  }
  else
  {
    this.checkResOffLimits=false;   
    this._roomenableroomallday = false;
    this._roomenablehourmin = false;  
    this.data_RstartTime = 0;
    this.data_RendTime = 0;
    this.checkresroominfo = false;
  }  
  
}

toggleresdayinfoVisibility(event)
{
  if (event.checked == true) {
    this._roomenablehourmin = false;     
    this.checkresroominfo = true;
    this.data_RstartTime = "";
    this.data_RendTime = "";
  }
  else{
    this._roomenablehourmin = true;            
    this.data_RstartTime = 0;
    this.data_RendTime = 0;
    this.checkresroominfo = false;
  }
}

 ngOnDestroy() {
	this._onDestroy.next();
	this._onDestroy.complete();
}
}
